import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { CommonService } from '../../../_services/common.service';
import { NavService } from '../../../_services/NavService.service';
import { UserService } from '../../../auth/_services';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { OrdersService } from '../../services/orders/orders.service';
import { PrintFormatsComponent } from '../../../print-formats/print-formats.component';
import { Helpers } from '../../../helpers';
import { environment } from '../../../../environments/environment';
import { data } from 'jquery';

@Component({
  selector: 'app-send-mail',
  templateUrl: './send-mail.component.html',
  styleUrls: ['./send-mail.component.scss']
})
export class SendMailComponent implements OnInit, OnChanges {

  static that: SendMailComponent;
  TenantId: any;
  CompanyId: any;
  userId: any;
  dataToSave: any = {};
  @Output() onCloseBtnClick = new EventEmitter<any>();
  isFormSubmit: boolean = false;
  @Input() ReferenceId: any;
  @Input() ReferenceType: any;
  @Input() showFooterbtn: boolean = false;
  hostUrl: any = environment.apiUrl;
  FromMail: any = {
    lable: 'From Mail',
    formControlName: 'FromMail',
    dataField: 'FromMail',
    isRequired: true,
    placeholder: 'Select From Mail',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true,
  };
  ToMail: any = {
    lable: 'To Mail',
    formControlName: 'ToMail',
    dataField: 'ToMail',
    isRequired: true,
    placeholder: 'Select To Mail',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    // isValueBind: true,
    // addTag: true,
    isMultipleSelect: true
  };
  CcMail: any = {
    lable: 'CC Mail',
    formControlName: 'CCMail',
    dataField: 'CCMail',
    isRequired: false,
    placeholder: 'Select CC Mail',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    // isValueBind: true,
    isMultipleSelect: true,
    // addTag: true,
  };
  Subject: any = {
    lable: "Subject",
    formControlName: 'Subject',
    dataField: 'Subject',
    isRequired: false,
    placeholder: "Subject",
  };
  Message: any = {
    lable: "Message",
    formControlName: 'Message',
    dataField: 'Message',
    isRequired: false,
    placeholder: "Message",
    type: 'textarea'
  };
  Attachment: any = {
    lable: "BYCUSTOMER.Attachment",
    formControlName: 'Attachment',
    dataField: 'Attachment',
    isRequired: true,
    placeholder: 'Select Attachment',
    isSearchByApi: false,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  IsSendAttachment: any = {
    lable: "SALESCOMP.SendOutstandingStatement",
    dataField: 'IsSendAttachment',
    formControlName: 'IsSendAttachment',
    typeOfField: 'toggle',
  }
  isDefaultEmailId: any;
  isDefaultEmailAddress: any;
  @Output() onSendEmail: EventEmitter<void> = new EventEmitter();
  @Input() isQuotation:boolean = false;
  @Input() IsEIRMail: boolean = false;
  @Input() ToEmailFromParent: any;
  @Input() TripNo: any;
  @Input() MessageFromParent: any;
  @Input() SubjectFromParent: any;

  constructor(private router: Router, private route: ActivatedRoute,
    private _appService: appService, private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private translate: TranslateService,
    private commonService: CommonService,
    private userService: UserService,
    private _navService: NavService,
    private mobileDetectionService: MobileDetectionService,
    private modalService: NgbModal,
    private dp: DatePipe,
    private orderService: OrdersService,
  ) {
    SendMailComponent.that = this;
  }

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.TenantId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).TenantId;
    this.fetchDefEmail();
    if(this.isQuotation == true){
      this.Attachment.dropdownList=[];
      let obj:any={};
      obj.value ='NewPrintQuote';
      obj.name ='Print Quotation';
      this.Attachment.dropdownList.push(obj);
      this.dataToSave.Attachment ='NewPrintQuote';
    }else{
      this.getPrintFormatTypes("");
    }
    this.LoadTaxApplicable();
  }

  getChangedValue(value, data) {
    
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if (data.dataField == 'ToMail') {
      this.dataToSave[data.dataField] = newValue;
    } else {
      this.dataToSave[data.dataField] = newValue;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['ReferenceId'] && changes['ReferenceType']) {
      this.InitMailData();
    }
  }

  InitMailData() {
    this.dataToSave = {};
    if (this.ReferenceType == 'Invoice') {
      this.GetInvoiceById();
    }
    if (this.ReferenceType == 'Quote') {
      this.getMailQuoteDataById();
    }
    if (this.ReferenceType == 'EIRMail') {
      this.GetEIRMailData();
    }
  }

  fetchDefEmail() {
    this._appService.GetByTwoId('EmailConfiguration', 'get_fromEmailSelectList', this.userId, '%%').subscribe(res => {
      this.FromMailList = res;
      this.FromMailList.forEach(element => {
        if (element.isDefault == true) {
          this.setDropdownData(this.FromMail, element.id, element.text);
        }
      });
    }, err => {
      console.log(err);
    });
  }

  setDropdownData(field: any, value: any, name: any) {
    field.dropdownList = [{ value, name }];
    this.dataToSave[field.dataField] = value;
    this.dataToSave.FromMailName = name;
  }

  ReferenceData: any = [];
  GetInvoiceById() {
    this._appService.GetById("Sales", "NewGetInvoiceById", this.ReferenceId).subscribe(response => {
      this.ReferenceData = response.Table[0];
      this.dataToSave.Subject = this.translate.instant("SALESCOMP.Invoice") +
        " " +
        this.ReferenceData.InvoiceNumber;

      this.dataToSave.Message = this.translate.instant("SALESCOMP.Dear") +
        " " +
        this.ReferenceData.CustomerName +
        "\n \n" +
        this.translate.instant(
          "SALESCOMP.EmailBodyMessage"
        );

      var mailList: any = [];
      if (this.ReferenceData.Email) {
        mailList.push(this.ReferenceData.Email);
      }
      if (this.ReferenceData.BillToPartyEmail) {
        mailList.push(this.ReferenceData.BillToPartyEmail);
      }
      this.dataToSave.ToMail = mailList;
      this.ToMail.dropdownList = [];
      mailList.forEach(element => {
        var obj: any = {};
        obj.value = element;
        obj.name = element;
        this.ToMail.dropdownList.push(obj);
      });

    },
      (err) => {
        this.toastr.error("Error While Getting Edit data", err);
      }
    );
  }

  FromMailList: any = [];
  getFromMailList(value, isScrollDown = false) {
    this.FromMail.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.FromMail.dropdownList.length / 20) + 1;
    }
    this._appService.GetByTwoId('EmailConfiguration', 'get_fromEmailSelectList', this.userId, value).subscribe(res => {
      res.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res];
      if (isScrollDown && res.length > this.FromMail.dropdownList.length) {
        dropdownList = dropdownList.concat(this.FromMail.dropdownList);
        this.FromMail = { ...this.FromMail, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.FromMail = { ...this.FromMail, dropdownList: [...dropdownList] });
      this.FromMail.isSearch = false;
    }),
      (error => {
        this.FromMail.isSearch = false;
      })
  }

  getToMailList(value, isScrollDown = false) {
    this.ToMail.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.ToMail.dropdownList.length / 20) + 1;
    }
    this._appService.GetByTwoId('EmailConfiguration', 'get_defaultText', this.userId, value).subscribe(res => {
      res.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res];
      if (isScrollDown && res.length > this.ToMail.dropdownList.length) {
        dropdownList = dropdownList.concat(this.ToMail.dropdownList);
        this.ToMail = { ...this.ToMail, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.ToMail = { ...this.ToMail, dropdownList: [...dropdownList] });
      this.ToMail.isSearch = false;
    }),
      (error => {
        this.ToMail.isSearch = false;
      })
  }

  getCCMailList(value, isScrollDown = false) {
    this.CcMail.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.CcMail.dropdownList.length / 20) + 1;
    }
    this._appService.GetByTwoId('EmailConfiguration', 'get_defaultText', this.userId, value).subscribe(res => {
      res.map(x => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res];
      if (isScrollDown && res.length > this.CcMail.dropdownList.length) {
        dropdownList = dropdownList.concat(this.CcMail.dropdownList);
        this.CcMail = { ...this.CcMail, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.CcMail = { ...this.CcMail, dropdownList: [...dropdownList] });
      this.CcMail.isSearch = false;
    }),
      (error => {
        this.CcMail.isSearch = false;
      })
  }

  getPrintFormatTypes(value, isScrollDown = false) {
    this.Attachment.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Attachment.dropdownList.length / 20) + 1;
    }
    this._appService.Get('Sales', 'GetSalesInvoicePrintFormats').subscribe(res => {
      res.map(x => {
        x.name = x.FormatType;
        x.value = x.Value;
      })
      let dropdownList = [...res];
      if (isScrollDown && res.length > this.Attachment.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Attachment.dropdownList);
        this.Attachment = { ...this.Attachment, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Attachment = { ...this.Attachment, dropdownList: [...dropdownList] });
      this.Attachment.isSearch = false;
      console.log('this.Attachment', this.Attachment);
    }),
      (error => {
        this.Attachment.isSearch = false;
      })
  }

  validateMultipleEmailsCommaSeparated(value) {
    var result = value.split(",");
    for (var i = 0; i < result.length; i++)
      if (!this.validateEmail(result[i]))
        return false;
    return true;
  }

  validateEmail(field) {
    var regex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b/i;
    return (regex.test(field)) ? true : false;
  }

  ValidateRequiredFieldOnSave() {
    var IsAllDataDone: any = true;
    if (!this.dataToSave[this.FromMail.dataField]) {
      IsAllDataDone = false;
    }
    if (!this.dataToSave[this.ToMail.dataField]) {
      IsAllDataDone = false;
    }
    if (!this.dataToSave[this.Subject.dataField]) {
      IsAllDataDone = false;
    }
    if (!this.dataToSave[this.Attachment.dataField]) {
      IsAllDataDone = false;
    }
    if (!IsAllDataDone) {
      var RequiredError = this.translate.instant("DriverDetailsById.RequiredError");
      Helpers.setLoading(false);
      this.toastr.warning(RequiredError, "error");
    }
    return IsAllDataDone;
  }

  SendInvoiceMail: any = {};
  @ViewChild(PrintFormatsComponent) PrintFormatsChild: PrintFormatsComponent;
  emailSentLog: any = {};
  // sendEmail() {
  //   this.isFormSubmit = true;
  //   var flag = this.ValidateRequiredFieldOnSave();
  //   if (flag != false) {
  //     var recipients = this.dataToSave.ToMail ? this.dataToSave.ToMail.join(',') : null;
  //     var cc_recipients = this.dataToSave.CCMail ? this.dataToSave.CCMail.join(',') : null;
  //     if (this.validateMultipleEmailsCommaSeparated(recipients) == false) {
  //       this.toastr.error('Please enter valid email address', 'Error');
  //       return;
  //     }
  //     if(cc_recipients){
  //       if (this.validateMultipleEmailsCommaSeparated(cc_recipients) == false) {
  //         this.toastr.error('Please enter valid email address for CC', 'Error');
  //         return;
  //       }
  //     }

  //     Helpers.setLoading(true);
  //     this.SendInvoiceMail = {};
  //     this.SendInvoiceMail.fromEmailId = this.dataToSave.FromMail;
  //     this.SendInvoiceMail.Recipient = recipients;
  //     this.SendInvoiceMail.ccEmail = cc_recipients;
  //     this.SendInvoiceMail.Message = this.dataToSave.Message;
  //     this.SendInvoiceMail.InvoiceId = this.ReferenceId;
  //     this.SendInvoiceMail.EmailSubject = this.dataToSave.Subject;
  //     this.SendInvoiceMail.Type = this.dataToSave.Attachment;
  //     this.SendInvoiceMail.InvoiceDate = this.ReferenceData.InvoiceDate;
  //     this.SendInvoiceMail.DueDate = this.ReferenceData.InvoiceDueDae;
  //     this.SendInvoiceMail.InvoiceNo = this.ReferenceData.InvoiceNumber;
  //     this.SendInvoiceMail.InvoiceAmount = this.ReferenceData.TotalAmount;
  //     this.SendInvoiceMail.isOutstandingStatement = this.dataToSave.IsSendAttachment;
  //     this.SendInvoiceMail.CompanyId = this.CompanyId;
  //     // Optionally emit event back to parent (if needed)
  //     this.PrintFormatsChild.divElements = null;
  //     if(this.isQuotation === true){
  //       this.PrintQuote(this.ReferenceId);
  //     }else{
  //       this.GetPrintData(this.ReferenceId, this.dataToSave.Attachment, 'Print');
  //     }


  //     setTimeout(() => {
  //       this.SendInvoiceMail.HtmlData = this.PrintFormatsChild.getHtml();
  //       if (this.SendInvoiceMail.HtmlData != null) {
  //         this._appService
  //           .Post("Sales", "SendInvoiceViaMail", this.SendInvoiceMail)
  //           .subscribe(
  //             (response) => {
  //               if (response == "true") {
  //                 this.toastr.success("Mail sent successfully", "OK");
  //                 Helpers.setLoading(false);
  //                 this.isFormSubmit = false;

  //                 this.emailSentLog.Transaction = this.ReferenceData.InvoiceNumber;
  //                 this.emailSentLog.TransactionType = "Invoice";
  //                 this.emailSentLog.From = this.dataToSave.FromMail;
  //                 this.emailSentLog.To = recipients;
  //                 this.emailSentLog.AttachmentType = this.dataToSave.Attachment;
  //                 this._appService
  //                   .Post("Sales", "SaveEmailSentLog", this.emailSentLog)
  //                   .subscribe(
  //                     (response) => {

  //                       Helpers.setLoading(false);
  //                     },
  //                     (err) => {
  //                       this.toastr.error(err._body.replace(/"/g, ""), "error");
  //                     }
  //                   );
  //                 //end
  //                 this.onSendEmail.emit();
  //                 this.onCloseBtnClick.emit();
  //                 Helpers.setLoading(false);
  //               } else {
  //                 this.toastr.error("Mail sent failed", "Error");
  //                 Helpers.setLoading(false);
  //               }
  //             },
  //             (err) => {
  //               console.log(err);
  //               Helpers.setLoading(false);
  //             }
  //           );
  //       } else {
  //         this.toastr.error("Please try again", " Error");
  //         Helpers.setLoading(false);
  //       }
  //     }, 5000);
  //   }
  // }

  sendEmail(){
    if(this.IsEIRMail === true){
      this.SendEIRCopyMail();
    }else{
      if(this.isQuotation === true){
        this.sendEmailQuote();
      } else{
        this.sendEmailInvoice();
      }
    }
  }

  LoadTaxApplicable() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "IsTaxApplicable")
      .subscribe(
        (response) => {
          if (response == '1') {
            this.TaxApplicableFlag = true;
          } else {
            this.TaxApplicableFlag = false;
          }
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }

  InvoiceTypeName: any;
  PrintDataModal: any = {};
  PrintData: any = [];
  TaxApplicableFlag: boolean = false;
  RoundOfAmount: any = 0;
  GetPrintData(Id, Type, ToDo) {
    Helpers.setLoading(true);
    this.PrintDataModal.InvoiceId = Id;
    if (Type == 'Detail1OnLatterPad' || Type == 'PDF_EInvoice' || Type == 'OnLatterPad_EInvoice') {
      this.PrintDataModal.Type = 'Detail1';
    } else {
      this.PrintDataModal.Type = Type;
    }

    if (Type == 'PrintInvoiceKSH' || Type == 'PrintInvoiceKSHSummary') {
      this._appService.Post("Sales", "GetPrintDataKSH", this.PrintDataModal).subscribe((response) => {
        this.PrintData = response;
        for (var i = 0; i < this.PrintData.length; i++) {
          let SGST: any = 0.0;
          let CGST: any = 0.0;
          let IGST: any = 0.0;
          this.PrintData[i].TotalQty = 0;
          this.PrintData[i].TotalDiscount = 0;
          this.PrintData[i].TotalAmount = 0;
          this.PrintData[i].NetTotalAmount = 0;
          this.PrintData[i].RoundOffValue = 0;
          this.PrintData[i].TotalCGST = 0;
          this.PrintData[i].TotalSGST = 0;
          this.PrintData[i].TotalIGST = 0;
          let UBSrNo = 1;
          this.PrintData[i].InvoiceDetails.forEach((element) => {
            //-----for Ub only------------
            if (Type == "AllInOne") {
              if (element.Unit == "Day") {
                element.SrNo = UBSrNo;
                UBSrNo++;
              }
            }
            //----------------------------
            if (
              element.Discount == null ||
              element.Discount == undefined ||
              element.Discount == ""
            ) {
              element.Discount = 0;
            }
            if (this.PrintData[i].IsTaxable == true) {
              if (element.CGST != null && element.CGST != 0) {
                CGST = element.Amount * (element.CGST / 100);
              }
              if (element.SGST != null && element.SGST != 0) {
                SGST = element.Amount * (element.SGST / 100);
              }
              if (element.IGST != null && element.IGST != 0) {
                IGST = element.Amount * (element.IGST / 100);
              }
            } else {
              element.ChargedGST = "NA";
            }
            this.PrintData[i].TotalAmount += element.Amount;
            this.PrintData[i].TotalDiscount += element.Discount;
            this.PrintData[i].TotalQty += element.Quantity;
            this.PrintData[i].TotalQty = Math.round(this.PrintData[i].TotalQty * 100) / 100;
            this.PrintData[i].TotalCGST += parseFloat(CGST.toFixed(2));
            this.PrintData[i].TotalSGST += parseFloat(SGST.toFixed(2));
            this.PrintData[i].TotalIGST += parseFloat(IGST.toFixed(2));
            CGST = 0.0;
            SGST = 0.0;
            IGST = 0.0;
          });
          this.PrintData[i].TotalAmount = parseFloat(this.PrintData[i].TotalAmount.toFixed(2));
          this.PrintData[i].TotalCGST = parseFloat(this.PrintData[i].TotalCGST.toFixed(2));
          this.PrintData[i].TotalSGST = parseFloat(this.PrintData[i].TotalSGST.toFixed(2));
          this.PrintData[i].TotalIGST = parseFloat(this.PrintData[i].TotalIGST.toFixed(2));
          if (this.TaxApplicableFlag == true) {
            this.PrintData[i].NetTotalAmount = this.PrintData[i].TotalAmount + this.PrintData[i].TotalCGST + this.PrintData[i].TotalSGST + this.PrintData[i].TotalIGST;
          } else {
            this.PrintData[i].NetTotalAmount = this.PrintData[i].TotalAmount;
          }
          this.PrintData[i].NetTotalAmount = parseFloat(this.PrintData[i].NetTotalAmount.toFixed(2));
          if (this.hostUrl != 'https://ksh.ifreightbox.net/') {
            this.RoundOfAmount = parseFloat((Math.round(this.PrintData[i].NetTotalAmount) - this.PrintData[i].NetTotalAmount).toFixed(2));
            this.PrintData[i].NetTotalAmount = Math.round(this.PrintData[i].NetTotalAmount);
          }
          this.PrintData[i].RoundOffValue = this.RoundOfAmount;

          this.PrintData[i].TotalTaxablevalue = 0;
          this.PrintData[i].ComponentToTalIGST = 0;
          this.PrintData[i].ComponentToTalSGST = 0;
          this.PrintData[i].ComponentToTalCGST = 0;
          this.PrintData[i].ComponentToTalGST = 0;
          if (Type != "AllInOne") {
            this.PrintData[i].ComponentRate.forEach((element) => {
              element.ComponentGST = 0;
              if (this.PrintData[i].IsTaxable != true) {
                element.IntegratedGST = 0;
                element.StateGST = 0;
                element.CentralGST = 0;
                element.IGSTRATE = 0;
                element.SGSTRATE = 0;
                element.CGSTRATE = 0;
              }
              this.PrintData[i].TotalTaxablevalue += element.TaxableValue;
              this.PrintData[i].ComponentToTalIGST += element.IGSTRATE;
              this.PrintData[i].ComponentToTalSGST += element.SGSTRATE;
              this.PrintData[i].ComponentToTalCGST += element.CGSTRATE;
              element.ComponentGST += element.IGSTRATE + element.SGSTRATE + element.CGSTRATE;

              this.PrintData[i].TotalTaxablevalue = parseFloat((this.PrintData[i].TotalTaxablevalue).toFixed(2));
              this.PrintData[i].ComponentToTalIGST = parseFloat((this.PrintData[i].ComponentToTalIGST).toFixed(2));
              this.PrintData[i].ComponentToTalSGST = parseFloat((this.PrintData[i].ComponentToTalSGST).toFixed(2));
              this.PrintData[i].ComponentToTalCGST = parseFloat((this.PrintData[i].ComponentToTalCGST).toFixed(2));
            });
            this.PrintData[i].ComponentToTalGST = this.PrintData[i].ComponentToTalIGST + this.PrintData[i].ComponentToTalSGST + this.PrintData[i].ComponentToTalCGST;
          } else {
            this.PrintData[i].TotalDamage = 0;
            this.PrintData[i].TotalShortage = 0;
            this.PrintData[i].TotalSealShort = 0;
            this.PrintData[i].TotalGoodQtyBoxes = 0;
            this.PrintData[i].TotalGoodQtyBottles = 0;
            this.PrintData[i].InvoiceProductDetail.forEach((element) => {
              //--------------------Bottles---------------------
              let TotalBottles = element.Quantity * 12;
              let TotalGoodBottles = TotalBottles - (element.Damage + element.Shortage + element.SealShort);
              let TotalGoodQuantityBoxes: number = 0;
              TotalGoodQuantityBoxes = TotalGoodBottles % 12;
              element.TotalGoodQuantityBottles = TotalGoodQuantityBoxes;
              //--------------------Boxes-----------------------
              let DamageBoxes = Math.floor(TotalGoodBottles / 12);
              element.TotalGoodQuantityBoxes = DamageBoxes;
              //----------------------Total---------------------
              this.PrintData[i].TotalDamage = this.PrintData[i].TotalDamage + element.Damage;
              this.PrintData[i].TotalShortage = this.PrintData[i].TotalShortage + element.Shortage;
              this.PrintData[i].TotalSealShort = this.PrintData[i].TotalSealShort + element.SealShort;
              this.PrintData[i].TotalGoodQtyBoxes = this.PrintData[i].TotalGoodQtyBoxes + element.TotalGoodQuantityBoxes;
              this.PrintData[i].TotalGoodQtyBottles = this.PrintData[i].TotalGoodQtyBottles + element.TotalGoodQuantityBottles;
            });
          }
          if (Type == "AllInOne") {
            this.PrintData[i].TotalHaltingAmount = 0.0;
            this.PrintData[i].TotalProductQuantity = 0;
            this.PrintData[i].InvoiceDetails.forEach((element) => {
              if (element.Unit == "Day") {
                this.PrintData[i].TotalHaltingAmount =
                  this.PrintData[i].TotalHaltingAmount + element.Amount;
              }
            });
            this.PrintData[i].InvoiceProductDetail.forEach((element) => {
              this.PrintData[i].TotalProductQuantity = this.PrintData[i].TotalProductQuantity + element.Quantity
            });
          }
        }
        if (ToDo == "Print") {
          this.InvoiceTypeName = Type;
          this.PrintFormatsChild.InvoiceId = Id;
          this.PrintFormatsChild.PrintData = this.PrintData;
          this.PrintFormatsChild.InvoiceType = Type;
          this.PrintFormatsChild.OnlyHtmlView = true;
          $("#PrintInvoicePCN").val("");
          this.PrintFormatsChild.PrintInvoice();
        }
      },
        (err) => {
          this.toastr.error("An error occured printing !", "error");
        }
      );
    } else {
      this._appService.Post("Sales", "GetPrintData", this.PrintDataModal).subscribe((response) => {

        this.PrintData = response;

        for (var i = 0; i < this.PrintData.length; i++) {

          let SGST: any = 0.0;

          let CGST: any = 0.0;

          let IGST: any = 0.0;



          this.PrintData[i].TotalQty = 0;

          this.PrintData[i].TotalDiscount = 0;

          this.PrintData[i].TotalAmount = 0;

          this.PrintData[i].NetTotalAmount = 0;

          this.PrintData[i].TotalCGST = 0;

          this.PrintData[i].TotalSGST = 0;

          this.PrintData[i].TotalIGST = 0;



          let UBSrNo = 1;



          this.PrintData[i].InvoiceDetails.forEach((element) => {

            //-----for Ub only------------

            if (Type == "AllInOne") {

              if (element.Unit == "Day") {

                element.SrNo = UBSrNo;

                UBSrNo++;

              }

            }

            //----------------------------

            if (

              element.Discount == null ||

              element.Discount == undefined ||

              element.Discount == ""

            ) {

              element.Discount = 0;

            }

            if (this.PrintData[i].IsTaxable == true) {

              if (element.CGST != null && element.CGST != 0) {

                CGST = element.Amount * (element.CGST / 100);

              }

              if (element.SGST != null && element.SGST != 0) {

                SGST = element.Amount * (element.SGST / 100);

              }

              if (element.IGST != null && element.IGST != 0) {

                IGST = element.Amount * (element.IGST / 100);

              }

            } else {

              element.ChargedGST = "NA";

            }



            this.PrintData[i].TotalAmount += element.Amount;

            this.PrintData[i].TotalDiscount += element.Discount;

            this.PrintData[i].TotalQty += element.Quantity;

            this.PrintData[i].TotalQty =

              Math.round(this.PrintData[i].TotalQty * 100) / 100;



            this.PrintData[i].TotalCGST += parseFloat(CGST.toFixed(2));

            this.PrintData[i].TotalSGST += parseFloat(SGST.toFixed(2));

            this.PrintData[i].TotalIGST += parseFloat(IGST.toFixed(2));

            CGST = 0.0;

            SGST = 0.0;

            IGST = 0.0;

            // if (this.PrintData[i].ChargeType == 'Credit Note') {

            //   element.Amount = element.Amount * -1;

            // }

          });



          this.PrintData[i].TotalAmount = parseFloat(this.PrintData[i].TotalAmount.toFixed(2));

          this.PrintData[i].TotalCGST = parseFloat(this.PrintData[i].TotalCGST.toFixed(2));

          this.PrintData[i].TotalSGST = parseFloat(this.PrintData[i].TotalSGST.toFixed(2));

          this.PrintData[i].TotalIGST = parseFloat(this.PrintData[i].TotalIGST.toFixed(2));

          this.PrintData[i].NetTotalAmount =

            this.PrintData[i].TotalAmount +

            this.PrintData[i].TotalCGST +

            this.PrintData[i].TotalSGST +

            this.PrintData[i].TotalIGST;

          this.PrintData[i].NetTotalAmount = parseFloat(this.PrintData[i].NetTotalAmount.toFixed(2));



          this.PrintData[i].TotalTaxablevalue = 0;

          this.PrintData[i].ComponentToTalIGST = 0;

          this.PrintData[i].ComponentToTalSGST = 0;

          this.PrintData[i].ComponentToTalCGST = 0;

          this.PrintData[i].ComponentToTalGST = 0;

          if (Type != "AllInOne") {

            this.PrintData[i].ComponentRate.forEach((element) => {

              element.ComponentGST = 0;

              if (this.PrintData[i].IsTaxable != true) {

                element.IntegratedGST = 0;

                element.StateGST = 0;

                element.CentralGST = 0;

                element.IGSTRATE = 0;

                element.SGSTRATE = 0;

                element.CGSTRATE = 0;

              }

              this.PrintData[i].TotalTaxablevalue += element.TaxableValue;

              this.PrintData[i].ComponentToTalIGST += element.IGSTRATE;

              this.PrintData[i].ComponentToTalSGST += element.SGSTRATE;

              this.PrintData[i].ComponentToTalCGST += element.CGSTRATE;

              element.ComponentGST +=

                element.IGSTRATE + element.SGSTRATE + element.CGSTRATE;


              this.PrintData[i].TotalTaxablevalue = parseFloat((this.PrintData[i].TotalTaxablevalue).toFixed(2));
              this.PrintData[i].ComponentToTalIGST = parseFloat((this.PrintData[i].ComponentToTalIGST).toFixed(2));
              this.PrintData[i].ComponentToTalSGST = parseFloat((this.PrintData[i].ComponentToTalSGST).toFixed(2));
              this.PrintData[i].ComponentToTalCGST = parseFloat((this.PrintData[i].ComponentToTalCGST).toFixed(2));
              // end

            });

            this.PrintData[i].ComponentToTalGST =

              parseFloat((this.PrintData[i].ComponentToTalIGST +

                this.PrintData[i].ComponentToTalSGST +

                this.PrintData[i].ComponentToTalCGST).toFixed(2));

          } else {

            this.PrintData[i].TotalDamage = 0;

            this.PrintData[i].TotalShortage = 0;

            this.PrintData[i].TotalSealShort = 0;

            this.PrintData[i].TotalGoodQtyBoxes = 0;

            this.PrintData[i].TotalGoodQtyBottles = 0;



            this.PrintData[i].InvoiceProductDetail.forEach((element) => {

              //--------------------Bottles---------------------

              let TotalBottles = element.Quantity * 12;

              let TotalGoodBottles =

                TotalBottles -

                (element.Damage + element.Shortage + element.SealShort);

              let TotalGoodQuantityBoxes: number = 0;

              TotalGoodQuantityBoxes = TotalGoodBottles % 12;

              element.TotalGoodQuantityBottles = TotalGoodQuantityBoxes;

              //--------------------Boxes-----------------------

              let DamageBoxes = Math.floor(TotalGoodBottles / 12);

              element.TotalGoodQuantityBoxes = DamageBoxes;

              //----------------------Total---------------------



              this.PrintData[i].TotalDamage =

                this.PrintData[i].TotalDamage + element.Damage;

              this.PrintData[i].TotalShortage =

                this.PrintData[i].TotalShortage + element.Shortage;

              this.PrintData[i].TotalSealShort =

                this.PrintData[i].TotalSealShort + element.SealShort;

              this.PrintData[i].TotalGoodQtyBoxes =

                this.PrintData[i].TotalGoodQtyBoxes + element.TotalGoodQuantityBoxes;

              this.PrintData[i].TotalGoodQtyBottles =

                this.PrintData[i].TotalGoodQtyBottles +

                element.TotalGoodQuantityBottles;

            });

          }

          if (Type == "AllInOne") {

            this.PrintData[i].TotalHaltingAmount = 0.0;

            this.PrintData[i].TotalProductQuantity = 0;

            this.PrintData[i].InvoiceDetails.forEach((element) => {

              if (element.Unit == "Day") {

                this.PrintData[i].TotalHaltingAmount =

                  this.PrintData[i].TotalHaltingAmount + element.Amount;

              }

            });

            this.PrintData[i].InvoiceProductDetail.forEach((element) => {

              this.PrintData[i].TotalProductQuantity =

                this.PrintData[i].TotalProductQuantity + element.Quantity;

            });

          }

        }

        if (ToDo == "Print") {
          this.InvoiceTypeName = Type;
          this.PrintFormatsChild.InvoiceId = Id;
          this.PrintFormatsChild.PrintData = this.PrintData;
          this.PrintFormatsChild.InvoiceType = Type;
          this.PrintFormatsChild.OnlyHtmlView = true;
          $("#PrintInvoicePCN").val("");
          this.PrintFormatsChild.PrintInvoice();
          //end

        }
      },

        (err) => {

          this.toastr.error(err._body.replace(/"/g, ""), "error");

        }

      );
    }

  }

  getMailQuoteDataById() {
    this._appService.GetById("OrdersByVehicle", "getMailQuoteDataById", this.ReferenceId).subscribe(response => {
      this.ReferenceData = response[0];
      this.dataToSave.Subject = this.ReferenceData.CustomerName + " " + this.translate.instant("BYCUSTOMER.Quotation") + " " + this.ReferenceData.OrderNo;

      this.dataToSave.Message = this.translate.instant("SALESCOMP.Dear") +
        " " +
        this.ReferenceData.CustomerName +
        "\n \n" +
        this.translate.instant(
          "SALESCOMP.EmailBodyMessageQuote"
        );

      var mailList: any = [];
      if (this.ReferenceData.Email) {
        mailList.push(this.ReferenceData.Email);
      }
      if (this.ReferenceData.BillToPartyEmail) {
        mailList.push(this.ReferenceData.BillToPartyEmail);
      }
      this.dataToSave.ToMail = mailList;
      this.ToMail.dropdownList = [];
      mailList.forEach(element => {
        var obj: any = {};
        obj.value = element;
        obj.name = element;
        this.ToMail.dropdownList.push(obj);
      });

      this.Attachment.dropdownList=[];
      let obj:any={};
      obj.value ='NewPrintQuote';
      obj.name ='Print Quotation';
      this.Attachment.dropdownList.push(obj);
      this.dataToSave.Attachment ='NewPrintQuote';
    },
      (err) => {
        this.toastr.error("Error While Getting Edit data", err);
      }
    );
  }

  PrintQuote(Id) {
    this.PrintFormatsChild.OrderId = Id;
    this.PrintFormatsChild.InvoiceType = 'NewPrintQuote';
    this.PrintFormatsChild.UserId = this.userId;
    this.PrintFormatsChild.CompId = this.CompanyId;
    this.PrintFormatsChild.OnlyHtmlView = true;
    this.PrintFormatsChild.PrintInvoice();
  }

  sendEmailInvoice() {
    this.isFormSubmit = true;
    var flag = this.ValidateRequiredFieldOnSave();
    if (flag != false) {
      var recipients = this.dataToSave.ToMail ? this.dataToSave.ToMail.join(',') : null;
      var cc_recipients = this.dataToSave.CCMail ? this.dataToSave.CCMail.join(',') : null;
      if (this.validateMultipleEmailsCommaSeparated(recipients) == false) {
        this.toastr.error('Please enter valid email address', 'Error');
        return;
      }
      if(cc_recipients){
        if (this.validateMultipleEmailsCommaSeparated(cc_recipients) == false) {
          this.toastr.error('Please enter valid email address for CC', 'Error');
          return;
        }
      }

      this.SendInvoiceMail = {};
      this.SendInvoiceMail.fromEmailId = this.dataToSave.FromMail;
      this.SendInvoiceMail.Recipient = recipients;
      this.SendInvoiceMail.ccEmail = cc_recipients;
      this.SendInvoiceMail.Message = this.dataToSave.Message;
      this.SendInvoiceMail.InvoiceId = this.ReferenceId;
      this.SendInvoiceMail.EmailSubject = this.dataToSave.Subject;
      this.SendInvoiceMail.Type = this.dataToSave.Attachment;
      this.SendInvoiceMail.InvoiceDate = this.ReferenceData.InvoiceDate;
      this.SendInvoiceMail.DueDate = this.ReferenceData.InvoiceDueDae;
      this.SendInvoiceMail.InvoiceNo = this.ReferenceData.InvoiceNumber;
      this.SendInvoiceMail.InvoiceAmount = this.ReferenceData.TotalAmount;
      this.SendInvoiceMail.isOutstandingStatement = this.dataToSave.IsSendAttachment;
      this.SendInvoiceMail.CompanyId = this.CompanyId;
      // Optionally emit event back to parent (if needed)
      this.PrintFormatsChild.divElements = null;
      this.GetPrintData(this.ReferenceId, this.dataToSave.Attachment, 'Print');


      setTimeout(() => {
        Helpers.setLoading(true);
        this.SendInvoiceMail.HtmlData = this.PrintFormatsChild.getHtml();
        if (this.SendInvoiceMail.HtmlData != null) {
          this._appService
            .Post("Sales", "SendInvoiceViaMail", this.SendInvoiceMail)
            .subscribe(
              (response) => {
                if (response == "true") {
                  this.toastr.success("Mail sent successfully", "OK");
                  // Helpers.setLoading(false);
                  this.isFormSubmit = false;

                  this.emailSentLog.Transaction = this.ReferenceData.InvoiceNumber;
                  this.emailSentLog.TransactionType = "Invoice";
                  this.emailSentLog.From = this.dataToSave.FromMail;
                  this.emailSentLog.To = recipients;
                  this.emailSentLog.AttachmentType = this.dataToSave.Attachment;
                  this._appService
                    .Post("Sales", "SaveEmailSentLog", this.emailSentLog)
                    .subscribe(
                      (response) => {

                        Helpers.setLoading(false);
                      },
                      (err) => {
                        this.toastr.error(err._body.replace(/"/g, ""), "error");
                      }
                    );
                  //end
                  this.onSendEmail.emit();
                  this.onCloseBtnClick.emit();
                  
                  setTimeout(() => {
                    Helpers.setLoading(false);
                  }, 2500);
                } else {
                  this.toastr.error("Mail sent failed", "Error");
                  Helpers.setLoading(false);
                }
              },
              (err) => {
                console.log(err);
                Helpers.setLoading(false);
              }
            );
        } else {
          this.toastr.error("Please try again", " Error");
          Helpers.setLoading(false);
        }
      }, 5000);
    }
  }

  sendEmailQuote() {
    this.isFormSubmit = true;
    Helpers.setLoading(true);
    var flag = this.ValidateRequiredFieldOnSave();
    if (flag != false) {
      var recipients = this.dataToSave.ToMail ? this.dataToSave.ToMail.join(',') : null;
      var cc_recipients = this.dataToSave.CCMail ? this.dataToSave.CCMail.join(',') : null;
      if (this.validateMultipleEmailsCommaSeparated(recipients) == false) {
        this.toastr.error('Please enter valid email address', 'Error');
        return;
      }
      if(cc_recipients){
        if (this.validateMultipleEmailsCommaSeparated(cc_recipients) == false) {
          this.toastr.error('Please enter valid email address for CC', 'Error');
          return;
        }
      }
      this.SendInvoiceMail = {};
      this.SendInvoiceMail.fromEmailId = this.dataToSave.FromMail;
      this.SendInvoiceMail.Recipient = recipients;
      this.SendInvoiceMail.ccEmail = cc_recipients;
      this.SendInvoiceMail.Message = this.dataToSave.Message;
      this.SendInvoiceMail.InvoiceId = this.ReferenceId;
      this.SendInvoiceMail.EmailSubject = this.dataToSave.Subject;
      this.SendInvoiceMail.Type = this.dataToSave.Attachment;
      this.SendInvoiceMail.InvoiceDate = this.ReferenceData.InvoiceDate;
      this.SendInvoiceMail.DueDate = this.ReferenceData.InvoiceDueDae;
      this.SendInvoiceMail.InvoiceNo = this.ReferenceData.OrderNo;
      this.SendInvoiceMail.InvoiceAmount = this.ReferenceData.TotalAmount;
      this.SendInvoiceMail.isOutstandingStatement = this.dataToSave.IsSendAttachment;
      this.SendInvoiceMail.CompanyId = this.CompanyId;
      this.SendInvoiceMail.FromLocation = this.ReferenceData.PickupLocationCode;
      this.SendInvoiceMail.ToLocation = this.ReferenceData.DeliveryLocationCode;
      this.SendInvoiceMail.TotalWeight = this.ReferenceData.sumOfWeight;
      this.SendInvoiceMail.CustomerName = this.ReferenceData.CustomerName;
      this.SendInvoiceMail.TotalAmount = this.ReferenceData.sumInvoiceAmount;
      this.SendInvoiceMail.VehicleType = this.ReferenceData.VehicleType;
      this.SendInvoiceMail.Id = this.ReferenceId;
      this.SendInvoiceMail.TransporterId = this.CompanyId;
      this.SendInvoiceMail.isQuotation = this.isQuotation;
      // Optionally emit event back to parent (if needed)
      this.PrintFormatsChild.divElements = null;

      setTimeout(() => {
        this._appService.Post("Sales", "SendQuoteViaMail", this.SendInvoiceMail).subscribe(
          (response) => {
            if (response == "true") {
              this.toastr.success("Mail sent successfully", "OK");
              Helpers.setLoading(false);
              this.isFormSubmit = false;
              this.emailSentLog = {
                OrderId: this.ReferenceId,
                Reason: null,
                FromEmail: this.dataToSave.FromMailName || this.dataToSave.FromMail,
                ToEmail: recipients,
                TransactionType: 'Quotation',
                Status: 'Sent',
                Remark: '',
                TotalAmount: this.ReferenceData.RecordIncAmt,
                CreatedBy: this.userId
              };
              this._appService.Post("OrdersByVehicle", "InsertOrderQuotationLog", this.emailSentLog).subscribe(
                (response) => {
                      Helpers.setLoading(false);
                },
                (err) => {
                      this.toastr.error(err._body.replace(/"/g, ""), "error");
                }
              );
              //end
              this.onSendEmail.emit();
              this.onCloseBtnClick.emit();
              Helpers.setLoading(false);
            } else {
              this.toastr.error("Mail sent failed", "Error");
              Helpers.setLoading(false);
            }
          },
          (err) => {
            console.log(err);
            Helpers.setLoading(false);
          }
        );
      }, 5000);
    }
  }

  closeModal(){
    this.onCloseBtnClick.emit();
  }

  GetEIRMailData(){
    this.dataToSave.Subject=this.SubjectFromParent;
    this.dataToSave.Message=this.MessageFromParent;
    var mailList: any = [];
    if (this.ToEmailFromParent) {
      mailList.push(this.ToEmailFromParent);
    }
    this.dataToSave.ToMail = mailList;
    this.ToMail.dropdownList = [];
    mailList.forEach(element => {
      var obj: any = {};
      obj.value = element;
      obj.name = element;
      this.ToMail.dropdownList.push(obj);
    });
    
    this.Attachment.dropdownList=[];
    let obj1:any={};
    obj1.value ='EIR Copy';
    obj1.name ='EIR Copy';
    this.Attachment.dropdownList.push(obj1);
    this.dataToSave.Attachment ='EIR Copy';
  }

  SendEIRCopyMail() {
    this.isFormSubmit = true;
    Helpers.setLoading(true);
    var flag = this.ValidateRequiredFieldOnSave();
    if (flag != false) {
      var recipients = this.dataToSave.ToMail ? this.dataToSave.ToMail.join(',') : null;
      var cc_recipients = this.dataToSave.CCMail ? this.dataToSave.CCMail.join(',') : null;
      if (this.validateMultipleEmailsCommaSeparated(recipients) == false) {
        this.toastr.error('Please enter valid email address', 'Error');
        return;
      }
      if(cc_recipients){
        if (this.validateMultipleEmailsCommaSeparated(cc_recipients) == false) {
          this.toastr.error('Please enter valid email address for CC', 'Error');
          return;
        }
      }

      const MailData = {
        fromEmailId : this.dataToSave.FromMail,
        Recipient : recipients,
        ccEmail : cc_recipients,
        Message : this.MessageFromParent,
        BookingId : this.ReferenceId,
        EmailSubject : this.SubjectFromParent,
        CompanyId : this.CompanyId,
      }

      // this.SendInvoiceMail.fromEmailId = this.dataToSave.FromMail;
      // this.SendInvoiceMail.Recipient = recipients;
      // this.SendInvoiceMail.ccEmail = cc_recipients;
      // this.SendInvoiceMail.Message = this.MessageFromParent;
      // this.SendInvoiceMail.BookingId = this.ReferenceId;
      // this.SendInvoiceMail.EmailSubject = this.SubjectFromParent
      // this.SendInvoiceMail.CompanyId = this.CompanyId;

      setTimeout(() => {
        this._appService.Post("Sales", "SendEIRCopyViaMail", MailData).subscribe(
          (response) => {
            if (response.length >  0) {
              this.toastr.success("Mail sent successfully", "OK");

              this.emailSentLog.Transaction = this.TripNo;
              this.emailSentLog.TransactionType = "EIR Copy";
              this.emailSentLog.From = this.dataToSave.FromMail;
              this.emailSentLog.To = recipients;
              this.emailSentLog.AttachmentType = "EIR Copy";
              this._appService.Post("Sales", "SaveEmailSentLog", this.emailSentLog).subscribe(
                (response) => {
                  Helpers.setLoading(false);
                },
                (err) => {
                  Helpers.setLoading(false);
                  this.toastr.error(err._body.replace(/"/g, ""), "error");
                }
              );
              //end
              this.onCloseBtnClick.emit();
              Helpers.setLoading(false);
            } else {
              Helpers.setLoading(false);
              this.toastr.error("Mail sent failed", "Error");
            }
          },
          (err) => {
            Helpers.setLoading(false);
            console.log(err);
          }
        );
      }, 5000);
    }
  }

}
